export default __webpack_public_path__ + "static/media/logo.b63fa1f3.svg";